import { NgModule } from '@angular/core';
import { StatusesHistoryRoutingModule } from 'history/statuses-history/statuses-history-routing.module';
import { StatusesHistoryComponent } from 'history/statuses-history/statuses-history.component';
import { OrderPageModule } from 'order/pages/order-page/order-page.module';
import { SharedModule } from 'shared/shared.module';
import { StatusChangeOrdersComponent } from './status-change-orders/status-change-orders.component';
import { StatusChangeComponent } from './status-change/status-change.component';

@NgModule({
  imports: [
    StatusesHistoryRoutingModule,
    SharedModule,
    OrderPageModule,
  ],
  declarations: [StatusesHistoryComponent, StatusChangeOrdersComponent, StatusChangeComponent],
})
export class StatusesHistoryModule {
}
